import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../Context/MainContext";
import { formatCurrency } from "../../utils/number.utils";
import PaymentDocTableComponent from "../../Components/PaymentDocTable.component";

const NNCCIssuedPage = () => {

    const { transactions } = useContext(AppContext);
    const [data, setData] = useState<any[]>([]);

    useEffect(() => {
        if (transactions.length > 0) {
            let tmp = transactions.filter((transaction: any) => (transaction.type === 'NNCC' || transaction.type === 'NNDD') && transaction.received === false);
            let invoices = transactions.filter((transaction: any) => transaction.type === 'FACTURA');
            tmp.forEach((nncc: any) => {
                let invoice = invoices.find((invoice: any) => invoice.rawValue && invoice.rawValue.cabecera ? invoice.rawValue.cabecera.documento.numDocumento : (invoice.externalID.split("-").slice(-1) === nncc.rawValue.factAsociada));
                nncc.invoice = invoice;
            });
            setData(tmp);
        }
    }, [transactions]);

    let columns = [
        { name: "Fecha", selector: (row: any) => new Date(row.date).toLocaleDateString(), sortable: true, sortFunction: (a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime() },
        { name: "Familia", selector: (row: any) => row.family || "-", sortable: true },
        { name: "Hoja de control", selector: (row: any) => row.controlSheet ? row.controlSheet.name : "-", sortable: true },
        { name: "Factura", selector: (row: any) => row.rawValue.factAsociada || "-" },
        { name: "Proveedor", selector: (row: any) => row.client, sortable: true },
        // { name: "Descripción", selector: (row: any) => row.description },
        { name: "Monto", selector: (row: any) => `$${formatCurrency(row.total)}`, sortable: true, sortFunction: (a: any, b: any) => parseInt(a.total) - parseInt(b.total) },
        { name: "Estado", selector: (row: any) => row.status },
        // { name: "Estado de pago", selector: (row: any) => row.paymentStatus },
    ];

    return (
        <PaymentDocTableComponent
            title="Notas de crédito emitidas"
            data={data}
            columns={columns}
        />
    );
}

export default NNCCIssuedPage;